import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedCountryView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'countries'
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removeCountry(value)
